import React from "react";
import axios from "axios";
import uuid from "react-uuid";
import { isYouTubeLink } from "../commons/CommonFunctions";


class CommonInspringStoryPhoto extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            inspiringStoriesOgData : {}
        }
    }

    componentDidMount() {
        if(this.props?.item && this.props?.item !== null){
            this.getLinkPreviewUrl(this.props?.item);
        }
    };


    getLinkPreviewUrl = (text) => {
        let data = {
            url: text
        }
        axios({
            method: 'POST',
            url: `${process.env.REACT_APP_userServiceURL}/recommend/ogscrapper`,
            data: data,
            withCredentials: true
        }).then((response) => {
            if (response?.data?.status === 200) {
                this.setState({
                    inspiringStoriesOgData: response?.data?.data
                })
            }
        }).catch((error) => {
            console.log("Error", error);
        })
    };

    redirectToInspiringStories = () => {
        window.open(this.props?.item, '_blank');
    }

    render() {
        const{inspiringStoriesOgData} = this.state;
        return (
            <figure style={{cursor:"pointer"}} onClick={() => isYouTubeLink(this.props.item) ? "javascript:void(0)" : this.redirectToInspiringStories()} href={isYouTubeLink(this.props.item) ? this.props.item : "javascript:void(0)"} data-fancybox={isYouTubeLink(this.props.item) ? `video${uuid()}` : null}>                
                <span><img 
                    src={inspiringStoriesOgData && inspiringStoriesOgData?.image ? inspiringStoriesOgData.image : "https://cdn.dscovr.com/images/inspire.webp"}
                     alt='' />
                     <h3>{this.props?.title}</h3>
                </span>
            </figure>
        );
    }
}

export default CommonInspringStoryPhoto;